// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-10385518].textarea-item.el-input {\n  width: 280px;\n}\n[data-v-10385518].textarea-item.el-input .el-input__inner {\n  width: 100%;\n  height: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 20px;\n}", ""]);
// Exports
module.exports = exports;
